import React, { useMemo } from 'react';
import withErrorBoundary from '@/utils/errorBoundary';
import * as Styles from './FastCheckoutPayment.styles';
import { FAST_CHECKOUT_PAYMENT_METHODS } from '@/pages/FastCheckout/FastCheckout.enum.jsx';
import { FastCheckoutCC } from './PaymentMethods';

const FastCheckoutPayment = ({
  paymentMethod,
  renderIframe,
  currentCreditCard,
  setCreditCardMethod,
  creditCardMethod,
  productIsTrial,
  finalizeBlock,
  productRenewalDate,
  locale,
  isMobile,
  isIframeLoaded,
  iframeInLoading,
}) => {
  const paymentMethodInfo = useMemo(() => {
    switch (paymentMethod) {
      case FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD:
        return (
          <FastCheckoutCC
            renewalDate={productRenewalDate}
            locale={locale.paymentMethods[FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD]}
            iframe={renderIframe}
            creditCardMethod={creditCardMethod}
            setCreditCardMethod={setCreditCardMethod}
            currentCreditCard={currentCreditCard}
            isIframeLoaded={isIframeLoaded}
            isMobile={isMobile}
            description={locale.paymentMethods[paymentMethod].label}
            iframeInLoading={iframeInLoading}
          />
        );
      case FAST_CHECKOUT_PAYMENT_METHODS.PIX:
        // Note: Temporary, dont have figma
        return <h2>Pix</h2>;
      case FAST_CHECKOUT_PAYMENT_METHODS.GP_BOLETO:
        // Note: Temporary, dont have figma
        return <h2>Boleto</h2>;
      default:
        return null;
    }
  }, [
    paymentMethod,
    renderIframe,
    currentCreditCard,
    setCreditCardMethod,
    creditCardMethod,
    productRenewalDate,
    locale.paymentMethods,
    iframeInLoading,
    isIframeLoaded,
    isMobile,
  ]);

  return (
    <Styles.PaymentAccordionWrapper>
      {paymentMethodInfo}
      {!iframeInLoading && (
      <>
        {isMobile && finalizeBlock}
        <Styles.RenewalInformation>
          {productIsTrial ? locale.renewalSamePaymentMethodInTrial : locale.renewalSamePaymentMethod}
        </Styles.RenewalInformation>
      </>
      )}
    </Styles.PaymentAccordionWrapper>
  );
};
export default withErrorBoundary(FastCheckoutPayment, 'FastCheckoutPayment');
